var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "services-list" },
    _vm._l(_vm.items, function (item, index) {
      return _c(
        "div",
        {
          key: "service_" + item.id,
          staticClass: "services-list__item service-item",
        },
        [
          _c("div", { staticClass: "service-item__content" }, [
            _c("div", { staticClass: "service-item__num" }, [
              _vm._v(_vm._s(index + 1)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "service-item__name" }, [
              _vm._v(_vm._s(item.name)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "service-item__price" }, [
              _vm._v(_vm._s(item.price)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "service-item__actions fieldset-actions" },
            [
              _c(
                "button",
                {
                  staticClass: "fieldset-actions__edit service-item__edit",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.editItem(item)
                    },
                  },
                },
                [_c("i", { staticClass: "fa fa-pen-to-square" })]
              ),
              _vm._v(" "),
              _c("delete-row-dialog", {
                staticClass: "fieldset-actions__delete service-item__delete",
                on: {
                  "delete-confirm": function ($event) {
                    return _vm.deleteItem(item)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [_vm._v("\n          Удалить строку?\n        ")]
                      },
                      proxy: true,
                    },
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("p", [
                            _vm._v(
                              _vm._s(item.name) + " - " + _vm._s(item.price)
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }